const style = () => ({
  timeContainer: {
    '& .MuiSelect-selectMenu': {
      color: '#3935C3',
      fontWeight: '500',
    },
  },
  timesCheck: {
    fontWeight: 400,
    '& .MuiInputBase-input': {
      lineHeight: '1rem',
      boxSizing: 'border-box',
      height: 32,
      padding: '8px 16px 8px 14px',
    },
    '& .MuiInputBase-root > span': {
      top: 4,
    },
  },
})
export default style
